import cardValidator from 'card-validator';

export const formatCreditCardField = (
  value: string,
  card: cardValidator.Card,
): string => {
  if (card) {
    const creditCardFormatted = Array.from(value)
      // insert spaces where there are gaps
      .reduce((agg, c, idx) => {
        if (card.gaps.includes(idx)) {
          return `${agg} ${c}`;
        }
        return `${agg}${c}`;
      }, '')
      // don't allow input more than cards max length + spaces
      .slice(0, Math.max(...card.lengths) + card.gaps.length);

    return creditCardFormatted;
  }

  return value;
};

export const formatExpiryDateField = (value: string): string => {
  const expiryDateFormatted = Array.from(value)
    .reduce((agg, c, idx) => (idx === 2 ? `${agg}/${c}` : `${agg}${c}`), '')
    .slice(0, 7); // MM/YYYY only

  return expiryDateFormatted;
};

export const formatCvvField = (
  value: string,
  card: cardValidator.Card | undefined,
): string => {
  const maxCvvLength = card ? card.code.size : 3;
  const cvvFormatted =
    cardValidator.cvv(value) &&
    value.replace(/\D/g, '').trim().slice(0, maxCvvLength);

  return cvvFormatted;
};

export const formatPostcode = (value: string): string => {
  const postcodeFormatted = value
    .replace(/[^a-zA-Z0-9_ ]/g, '') // only allow letters, numbers and spaces
    .toUpperCase()
    .slice(0, 20);

  return postcodeFormatted;
};

export const validateCreditCard = (value: string): boolean => {
  const result = cardValidator.number(value);

  return result.isValid;
};

export const validateExpiryDate = (value: string): boolean => {
  const result = cardValidator.expirationDate(value);

  return result.isValid;
};

export const validateCVV =
  (validNumber: cardValidator.validNumber) =>
  (value: string): boolean => {
    const maxLength = validNumber?.card?.code?.size;
    const result = cardValidator.cvv(value, maxLength);

    return result.isValid;
  };

export const validatePostcode = (value: string): boolean => {
  const maxLength = 20;

  return value.length <= maxLength;
};
